import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'

import { AppConfigService } from 'app/app-config.service'
import { UserStore } from 'app/store/user.store'

export const canViewStoreCreditsGuard: CanActivateFn = () => {
  const userStore = inject(UserStore)
  const appConfigService = inject(AppConfigService)
  const storefrontId = appConfigService.getAppConfig?.id

  return !!userStore
    .user()
    ?.permissions.some(permission => permission.name === 'storefronts.gift-cards.' + storefrontId)
}
